import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import qs from 'qs';

import './CompleteResetPasswordPage.scss';

import { generateDispatchToPropsMap, generateExternalUrlByPath } from 'helpers';
import { initCompleteResetPasswordPage, InitCompleteResetPasswordPageFunc } from 'store/checkout/actions';
import { Loader } from 'components';
import { AppState } from 'store';
import { BasketErrorModel } from 'models/Errors';
import { routes } from 'routes';

interface StateProps {
    isCompleteResetPasswordPageInitializing: boolean;
    completeResetPasswordError: BasketErrorModel | null;
}

interface DispatchProps {
    initCompleteResetPasswordPage: InitCompleteResetPasswordPageFunc;
}

class CompleteResetPasswordPage extends Component<StateProps & DispatchProps & RouteComponentProps> {
    componentDidMount() {
        const basketId = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).basketId || null;
        this.props.initCompleteResetPasswordPage(basketId);
    }

    componentDidUpdate(prevProps: StateProps): void {
        if (prevProps.isCompleteResetPasswordPageInitializing && !this.props.isCompleteResetPasswordPageInitializing) {
            if (!this.props.completeResetPasswordError) {
                this.redirectTo(routes.deliveryDetails.path);
            } else {
                this.redirectTo(routes.basket.path);
            }
        }
    }

    render(): JSX.Element {
        return (
            <div className='complete-reset-password-page'>
                <Loader show={true} />
            </div>
        );
    }

    redirectTo(path: string): void {
        // trying to remove current url from browser history - to not allow user return to this page by click 'Back' in browser
        window.location.replace(generateExternalUrlByPath(path));
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        isCompleteResetPasswordPageInitializing: state.checkoutState.isCompleteResetPasswordPageInitializing,
        completeResetPasswordError: state.checkoutState.completeResetPasswordError
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [initCompleteResetPasswordPage]);
}

export default connect(mapStateToProps, mapDispatchToProps)(CompleteResetPasswordPage);